import { render, staticRenderFns } from "./PremiumFeaturesDialog.vue?vue&type=template&id=3ed7012a&scoped=true"
import script from "./PremiumFeaturesDialog.vue?vue&type=script&lang=js"
export * from "./PremiumFeaturesDialog.vue?vue&type=script&lang=js"
import style0 from "./PremiumFeaturesDialog.vue?vue&type=style&index=0&id=3ed7012a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed7012a",
  null
  
)

export default component.exports